package com.cs.ejobin.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.cs.ejobin.i18n.AppLanguage
import com.cs.ejobin.i18n.LocalI18n
import com.cs.ejobin.ui.theme.AppColors
import ejobin.composeapp.generated.resources.Res
import ejobin.composeapp.generated.resources.eJobin_logo
import org.jetbrains.compose.resources.painterResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ScreenScaffold(
    title: String,
    scrollable: Boolean = false,
    topActions: @Composable RowScope.() -> Unit = {},
    content: @Composable ColumnScope.() -> Unit,
) {
    val i18n = LocalI18n.current
    var expanded by remember { mutableStateOf(false) }

    val primaryTextButtonColors = ButtonDefaults.textButtonColors(
        contentColor = AppColors.Primary
    )

    val logoAlpha = 0.14f
    val logoSize: Dp = 420.dp

    Box(modifier = Modifier.fillMaxSize()) {
        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.Center
        ) {
            Image(
                painter = painterResource(Res.drawable.eJobin_logo),
                contentDescription = null,
                modifier = Modifier
                    .size(logoSize)
                    .alpha(logoAlpha)
            )
        }

        Scaffold(
            containerColor = Color.Transparent,
            topBar = {
                TopAppBar(
                    title = {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(8.dp)
                        ) {
                            Image(
                                painter = painterResource(Res.drawable.eJobin_logo),
                                contentDescription = "eJobin",
                                modifier = Modifier
                                    .size(28.dp)
                            )

                            if (title.isNotBlank()) {
                                Text(title)
                            }
                        }
                    },
                    actions = {
                        topActions()

                        Box {
                            TextButton(
                                onClick = { expanded = true },
                                colors = primaryTextButtonColors
                            ) { Text(i18n.language.code.uppercase()) }

                            DropdownMenu(
                                expanded = expanded,
                                onDismissRequest = { expanded = false }
                            ) {
                                AppLanguage.entries.forEach { lang ->
                                    DropdownMenuItem(
                                        text = { Text(lang.label) },
                                        onClick = {
                                            i18n.setLanguage(lang)
                                            expanded = false
                                        }
                                    )
                                }
                            }
                        }
                    },
                    colors = TopAppBarDefaults.topAppBarColors(
                        containerColor = MaterialTheme.colorScheme.background.copy(alpha = 0.90f)
                    )
                )
            }
        ) { pad ->
            val base = Modifier
                .padding(pad)
                .fillMaxSize()
                .padding(16.dp)

            if (scrollable) {
                Column(
                    modifier = base.verticalScroll(rememberScrollState()),
                    verticalArrangement = Arrangement.SpaceBetween
                ) {
                    Column(
                        modifier = Modifier.fillMaxWidth(),
                        verticalArrangement = Arrangement.spacedBy(12.dp)
                    ) {
                        content()
                    }

                    Spacer(Modifier.height(12.dp))
                    AppFooter()
                }
            } else {
                Column(
                    modifier = base,
                    verticalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    content()
                    AppFooter()
                }
            }
        }
    }
}